import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { ASSETS_PATH } from '../services/endpoints';
let loadedExternals = false;
const backend = {
  loadPath: `${ASSETS_PATH}/locales/{{lng}}.json`
};
const lng = window.location.href.split('/')[3];
export function configureTranslations() {
  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng,
      backend,
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: false,
        bindI18n: 'added', //tryed both
        bindI18nStore: 'added' //tryed both
      },
      returnNull: false,
      partialBundledLanguages: true
    });
}

export const addRemotesLocales = (externalLocales: JSON) => {
  if (!loadedExternals) {
    i18n.addResourceBundle(
      'en',
      'translation',
      externalLocales['en'],
      true,
      true
    );
    i18n.addResourceBundle(
      'es',
      'translation',
      externalLocales['es'],
      true,
      true
    );
    loadedExternals = true;
  }
};
